import styled from "styled-components";
import { mediaMax } from "../../../../styles/mediaQueries";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${mediaMax.tabletLandscape`
    flex-direction: column;
  `};
`;

export const Nav = styled.div`
  width: 300px;
  padding: 0;
  margin-top: 26px;
  border-top: 2px solid rgba(0,0,0,.2);
  ${mediaMax.tabletLandscape`
    width:60%;
  `};
  ${mediaMax.tablet`
    width:100%;
  `};

  h3 {
    font-family: "SangBleu Kingdom",sans-serif;
    font-size: 21px;
    line-height: 28px;
    margin: 0 0 8px 0;
    padding-top: 10px;
  }

  p{
      font-family: "SangBleu Kingdom",sans-serif;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      letter-spacing: -0.3px;
      padding-right: 80px;
  }
`;

export const Map = styled.div`
  width: calc(95% - 360px);
  height: auto;
  ${mediaMax.tabletLandscape`
    width: 100%;
    margin-top: 60px;
  `};
  ${mediaMax.phoneXL`
    width: 100%;
    height: 50vh;
    margin-top: 0;
    margin-bottom: 24px;
  `};

  img {
    width: 100%;
    cursor: pointer;
  }
`;

export const MapModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, .5);
  z-index: 2;
  cursor: pointer;

  img {
    display: block;
    width: auto;
  }
`;
